import { useMutation } from '@tanstack/react-query';
import { useFetcher } from '../../graphql';

/**
 * Leave an Activity call: ends only the caller's own Call row (RINGING or
 * ACTIVE -> ENDED/CANCELLED); other participants' rows are untouched. Used
 * for asset/group call teardown — unlike useEndActivityCall, this does not
 * terminate the room for everyone still on the call.
 */
export const useLeaveActivityCall = () => {
  const fetcherFn = useFetcher<
    { call: { leaveActivityCall: { call: { id: string; state: string } } } },
    { input: { issueId: string } }
  >(LEAVE_ACTIVITY_CALL);

  return useMutation({
    mutationFn: async (issueId: string): Promise<{ id: string; state: string }> => {
      const data = await fetcherFn({ input: { issueId } });
      return data.call.leaveActivityCall.call;
    },
  });
};

const LEAVE_ACTIVITY_CALL = `
  mutation LEAVE_ACTIVITY_CALL($input: LeaveActivityCallInput!) {
    call {
      leaveActivityCall(input: $input) {
        call {
          id
          state
        }
      }
    }
  }
`;
